import { View } from "react-native";
import ImpactBackgroundGradient from "src/components/ImpactBackgroundGradient";
import OpacityView from "src/components/OpacityView";
import useStyle from "src/hooks/useStyle";
import useEditCoverGalleryStore from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryStore";
import { EditCoverGalleryModalProps } from "src/screens/(internal)/EditCoverGalleryModal/types";
import { color } from "src/styles";
import { radiusMedium } from "src/styles/radius";
import { paddingLarge } from "src/styles/spacing";
import { AnimatePresence, Image } from "src/swsh-native";

const getBorderRadius = (
	coverProfile: EditCoverGalleryModalProps["coverProfile"],
	size: number,
): number => {
	switch (coverProfile) {
		case "Squircle":
			return radiusMedium;
		case "Circle":
		default:
			return size / 2;
	}
};

const EditCoverPreview = ({ height }: { height: number }) => {
	const coverProfile = useEditCoverGalleryStore((state) => state.coverProfile ?? "Circle");
	const selection = useEditCoverGalleryStore((state) => state.selection);
	const size = 0.3 * height;
	const padding = Math.floor(0.02 * size);
	const contentSize = size - padding * 2;
	const { theme } = useStyle();

	return (
		<View
			style={{
				width: "100%",
				alignItems: "center",
				justifyContent: "center",
				marginVertical: paddingLarge,
			}}
		>
			<ImpactBackgroundGradient
				style={{
					width: size,
					height: size,
					borderRadius: getBorderRadius(coverProfile, size),
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<AnimatePresence>
					<OpacityView
						key={selection?.url}
						entering={!!selection}
						style={{
							position: "absolute",
							width: contentSize,
							height: contentSize,
						}}
					>
						{selection ? (
							<Image
								dim={{
									width: contentSize,
									height: contentSize,
								}}
								alt="Selected Cover"
								src={selection.url}
								style={{
									borderRadius: getBorderRadius(coverProfile, contentSize),
									backgroundColor: color.InputPlaceholder[theme],
								}}
							/>
						) : (
							<View
								style={{
									width: contentSize,
									height: contentSize,
									borderRadius: getBorderRadius(coverProfile, contentSize),
									backgroundColor: color.InputPlaceholder[theme],
								}}
							/>
						)}
					</OpacityView>
				</AnimatePresence>
			</ImpactBackgroundGradient>
		</View>
	);
};
export default EditCoverPreview;
